import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
    inheritAttrs: false,
};

import InputControl from './input-control.vue';
import LabelBox from './label-box.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'input-box',
  props: {
    id: null,
    name: null,
    label: { type: [String, Boolean] },
    labelClass: null,
    controlClass: null
  },
  setup(__props: any) {

const props = __props as {
    id?: string;
    name?: string;
    label?: string | boolean;
    labelClass?: string;
    controlClass?: string;
}



return { __sfc: true,props, InputControl, LabelBox }
}

})